type AnalysisColumn = {
  dataIndex?: string | number | symbol | readonly (string | number)[];
  title?: unknown;
  isAvg?: boolean;
};

const isEmptyValue = (value: unknown) =>
  value === '' || value === null || value === undefined || value === '-';

// 仅“均分 / 平均分”相关列需要保留两位小数
const AVG_TITLE_REG = /均分|平均分/;
// 学科均分表各科/模块均分：xxxCourseAvg、xxxFullScoreCourseAvg
const AVG_DATAINDEX_REG = /CourseAvg$/;
// 单科/四率“X总”（如 CHINESEFullScore），区分于满分列 fullScore（小写 f）
const FULL_SCORE_AVG_REG = /FullScore$/;

const isAvgColumn = (column?: AnalysisColumn) => {
  if (column?.isAvg) return true;

  const dataIndex = String(column?.dataIndex || '');
  const title = String(column?.title || '');

  if (AVG_TITLE_REG.test(title)) return true;
  if (dataIndex === 'avgScore') return true;
  if (AVG_DATAINDEX_REG.test(dataIndex)) return true;
  if (FULL_SCORE_AVG_REG.test(dataIndex)) return true;

  return false;
};

export const formatAnalysisTableValue = (
  value: unknown,
  column?: AnalysisColumn
) => {
  if (isEmptyValue(value) || !isAvgColumn(column)) return value;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value.toFixed(2) : value;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    const percentMatch = trimmed.match(/^(-?\d+(?:\.\d+)?)%$/);

    if (percentMatch) return `${Number(percentMatch[1]).toFixed(2)}%`;
    if (/^-?\d+\.\d+$/.test(trimmed)) return Number(trimmed).toFixed(2);
  }

  return value;
};

export const formatAnalysisTableRows = (
  rows: Record<string, unknown>[],
  columns: AnalysisColumn[]
) => {
  return rows.map((row) => {
    const next = { ...row };

    columns.forEach((column) => {
      const dataIndex = column.dataIndex;
      if (dataIndex === undefined || dataIndex === null) return;

      const key = String(dataIndex);
      if (Object.prototype.hasOwnProperty.call(next, key)) {
        next[key] = formatAnalysisTableValue(next[key], column);
      }
    });

    return next;
  });
};
